export default "__VITE_ASSET__e32e0318__"